module.exports = __webpack_public_path__ + "static/img/mycompass_loginlogo.80c67b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/mycompass_loginlogo.png
// module id = 3v2w
// module chunks = 0